import type { TransportMode } from '../../../../../models/transport-mode.enum';
import TransportModeIcon from '../TransportModeIcon';
import { TransportModeHelper } from '../../../../../helpers/transport-mode.helper';

function TransportModeCheckbox({
  transportMode,
  checked,
  className,
  isInvalid = false,
  renderAsChips,
  onChange,
}: {
  transportMode: TransportMode;
  checked: boolean;
  className?: string;
  isInvalid?: boolean;
  renderAsChips?: boolean;
  onChange: (transportMode: TransportMode, checked: boolean) => void;
}) {
  function handleChange() {
    onChange(transportMode, !checked);
  }

  return (
    <div className={`${renderAsChips ? 'filter-chip' : 'transport-mode-checkbox form-check'} ${className ?? ''}`}>
      {!renderAsChips && (
        <input id={transportMode} type="checkbox" className={`form-check-input ${isInvalid ? 'is-invalid' : ''}`} aria-invalid={isInvalid} checked={checked} onChange={handleChange} />
      )}
      <label htmlFor={transportMode} className={`${renderAsChips ? 'filter-chip__label d-flex align-items-center rounded' : 'form-check-label'} fw-normal d-flex align-items-center text-nowrap`}>
        <TransportModeIcon
          className={`${renderAsChips ? 'filter-chip__icon' : 'transport-mode-checkbox__icon'} me-1`}
          transportMode={transportMode}
          overrideAltText=""
          renderAsSquare={!renderAsChips}
        />
        {renderAsChips && (
          <input
            id={transportMode}
            type="checkbox"
            className={`filter-chip__input position-absolute ${isInvalid ? 'is-invalid' : ''}`}
            aria-invalid={isInvalid}
            checked={checked}
            onChange={handleChange}
          />
        )}
        {TransportModeHelper.translate(transportMode)}
      </label>
    </div>
  );
}

export default TransportModeCheckbox;
